import { html } from "lit";
import { styleMap } from "lit/directives/style-map.js";

export const _radioButton = ({ height = "1em", width = "1em" } = {}) =>
  html`
    <svg
      style="${styleMap({ height, width, position: "relative", bottom: "0" })}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <!-- Filled Circle -->
      <circle cx="12" cy="12" r="10" fill="currentColor" />
    </svg>
  `;
